import { AggregatedError } from "@otto-ec/assets-core-utils/nano-effect";
import { captureError, type APMLabelsMap } from "@otto-ec/global-resources/apm";

function normalizeError(error: unknown): string {
	if (error instanceof Error) {
		return `${error.name}: ${error.message}`;
	} else if (typeof error === "string") {
		return error;
	} else if (typeof error === "number") {
		return error.toString();
	} else if (error instanceof AggregatedError) {
		let message = "";
		for (message in error.errors) {
			message.concat(`${error.toString()} ,`);
		}
		return message;
	} else {
		return "unknown error";
	}
}

export function captureErrorWithPayload(message: string, service: string, module: string, key: string, error?: unknown, labels?: APMLabelsMap): void {
	const [errorMessage, info, options] = [
		new Error(message),
		{
			team: "ft9",
			service: service,
			module: module,
		},
		{
			type: key,
			...((error || labels) && {
				custom: {
					...(error ? { message_or_status_codes: normalizeError(error) } : {}),
					...labels,
				},
			}),
		},
	];

	captureError(errorMessage, info, options);
}
